import { T } from '../../styles/theme'
import { SectionLabel } from '../../components/ui'

const TIPO_INFO = {
  sin_registro: { icon: '🍽️', label: 'Sin registrar comidas' },
  no_progreso: { icon: '📉', label: 'Sin progreso' },
  deficit_excesivo: { icon: '⚠️', label: 'Déficit excesivo' },
  proteina_baja: { icon: '🥩', label: 'Proteína baja' },
  superavit: { icon: '⬆️', label: 'Superávit' },
  adherencia_baja: { icon: '📊', label: 'Adherencia baja' },
}

function AlertRow({ a, color, onSelect }) {
  const info = TIPO_INFO[a.tipo] ?? { icon: '🔔', label: a.tipo }
  return (
    <div
      onClick={() => onSelect?.(a.pacienteId)}
      style={{
        background: T.card, borderRadius: 12, padding: '12px 14px', margin: '0 16px 8px',
        display: 'flex', gap: 10, borderLeft: `3px solid ${color}`,
        cursor: onSelect ? 'pointer' : 'default',
      }}
    >
      <span style={{ fontSize: 16 }}>{info.icon}</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 11, color: T.muted, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 2 }}>{info.label}</div>
        <div style={{ fontSize: 13, fontWeight: 600 }}>{a.paciente}</div>
        <div style={{ fontSize: 12, color: T.sub, marginTop: 2 }}>{a.mensaje}</div>
      </div>
      {onSelect && <span style={{ color: T.muted, fontSize: 16, alignSelf: 'center' }}>›</span>}
    </div>
  )
}

export default function Alertas({ alerts, onSelect }) {
  const criticas = alerts.filter(a => a.nivel === 'critica')
  const avisos = alerts.filter(a => a.nivel === 'aviso')

  return (
    <div>
      <div style={{ padding: '52px 20px 12px' }}>
        <div style={{ fontSize: 26, fontWeight: 700, letterSpacing: -0.5 }}>Alertas</div>
        <div style={{ fontSize: 13, color: T.muted, marginTop: 2 }}>
          {alerts.length > 0 ? `${alerts.length} activas · toca una para ir al paciente` : 'Todo en orden'}
        </div>
      </div>

      {alerts.length === 0 && (
        <div style={{ textAlign: 'center', color: T.muted, padding: 40 }}>
          ✅ Sin alertas activas
        </div>
      )}

      {criticas.length > 0 && <>
        <SectionLabel>Críticas</SectionLabel>
        {criticas.map((a, i) => <AlertRow key={i} a={a} color={T.danger} onSelect={onSelect} />)}
      </>}

      {avisos.length > 0 && <>
        <SectionLabel style={{ margin: '16px 20px 8px' }}>Avisos</SectionLabel>
        {avisos.map((a, i) => <AlertRow key={i} a={a} color={T.warn} onSelect={onSelect} />)}
      </>}
    </div>
  )
}
